import { CabinetAccountingApiService } from '@/services/backend/cabinet/provider/accounting';
import { Fl44CabinetProviderContracts } from '@/services/backend/cabinet/provider/contracts';
import { CabinetProviderRatingHistory } from '@/services/backend/cabinet/provider/rating-history';

export const provider = {
    accounting: new CabinetAccountingApiService(),
    contracts: new Fl44CabinetProviderContracts(),
    ratingHistory: new CabinetProviderRatingHistory()
};
